// Вызов api: в Telegram — подпись initData, на сайте — токен сессии. Ошибка — ApiError с кодом (текст — из словаря).
import { API_URL } from './config.ts';
import { initData, inTelegram } from './telegram.ts';
import { store } from './storage.ts';
import { firstTouch } from './source.ts';

const K_SESSION = 'mk_session';
export const session = {
  get: () => store.get(K_SESSION),
  set: (t: string) => store.set(K_SESSION, t),
  clear: () => store.del(K_SESSION),
};

export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number) { super(message); }
}

// действия, при которых может появиться профиль, — с источником прихода
const WITH_SOURCE = new Set(['auth_guest', 'auth_email_verify', 'auth_tg_start', 'auth_vk_start', 'me']);

export async function api<T = any>(action: string, body: Record<string, unknown> = {}): Promise<T> {
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  if (inTelegram()) headers['x-init-data'] = initData();
  const s = session.get();
  if (s) headers['x-session'] = s;
  let r: Response;
  try {
    r = await fetch(API_URL, {
      method: 'POST', headers,
      body: JSON.stringify({ action, ...body, ...(WITH_SOURCE.has(action) ? { src: firstTouch() } : {}) }),
    });
  } catch {
    throw new ApiError('network', 'Нет связи с сервером', 0);
  }
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiError(data.error ?? 'server', data.message ?? 'Ошибка', r.status);
  // сессия, выданная входом, сразу запоминается
  if (data && typeof data.session === 'string') session.set(data.session);
  return data as T;
}
